import { Column } from "@tento-ui/component-builtin";
import { Squircle } from "@tento-ui/components/squircle/squircle";
import { deepFrozen } from "@tento-lona/sheets/internal-ui";

/** The RSVP choices of an event's context menu (going, not going, maybe). */
export namespace RsvpStatusList {
  export const STATUSES = [
    { value: "accepted", label: "Going", color: "var(--green)" },
    { value: "declined", label: "Not going", color: "var(--red)" },
    { value: "tentative", label: "Maybe", color: "var(--yellow)" },
  ];
  deepFrozen(STATUSES);

  export function makeWith(
    onSelectStatus: (status: string) => void,
  ): HTMLElement {
    let list = Column.builder();

    for (const status of STATUSES) {
      const $icon = Squircle.makeWith({
        fill: status.color,
      }).assignStyles({
        width: "16px",
        height: "16px",
        margin: "0px 8px 0px 0px",
      });

      list = list.cell(status.label, {
        $icon,
        pointerEvents: {
          onClick: () => onSelectStatus(status.value),
        },
      });
    }

    return list
      .assignStyles({
        padding: "6px",
      })
      .build();
  }
}
